export default {"src":"/_next/static/media/cover-aboutTop.504b3468.svg","height":242,"width":1112};